<template>
  <div>
    <el-popover placement="bottom" width="427" trigger="hover">
     <div class="pop-title">
      悦享人事系列产品（按产品单独计费）
     </div>
     <div class="apps">
        <div class="appitem" @click="linktoapp('/index')">
          <img src="@/assets/gzt1.png" alt="" />
          <div class="appname">悦享工资条</div>
        </div>
        <div class="appitem" @click="linktoapp('smsindex')">
          <img src="@/assets/sms1.png" alt="" />
          <div class="appname">短信中心</div>
        </div>
        <div class="appitem" @click="linktoapp('lovecardindex')">
          <img src="@/assets/love1.png" alt="" />
          <div class="appname">悦享心语</div>
        </div>
      </div>
      <div class="otherapp" slot="reference">
        <img src="@/assets/allappicon.png" alt="" />
        <span>更多应用</span>
      </div>
    </el-popover>
  </div>
</template>

<script>
export default {
  methods: {
    linktoapp (path) {
      if(path=='smsindex'){
        // window.location.href ="http://sms.prosuntech.com/#/smsindex" 
        window.location.href ="https://sms.joyousoa.com/#/smsindex" 
      }else if(path=='lovecardindex'){
        // window.location.href ="http://wish.prosuntech.com/#/lovecardindex" 
        window.location.href ="https://wish.joyousoa.com/#/lovecardindex" 
      }else{
      this.$router.push(path)
      }
    },
  },
}
</script>

<style scoped lang="less">

.pop-title{
    color:#000;
    padding-bottom:8px;
    border-bottom:1px solid #D6D6D6;
  }
.apps {
  display: flex;
  align-items: center;
  justify-content: left;
  flex-wrap: wrap;
  cursor: pointer;
  margin-left:12px;
  .appitem {
    width: 120px;
    height: 84px;
    box-shadow: 0px 0px 1px 0px rgba(55,124,253,0.3);
    border-radius: 4px;
    margin-top: 27px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    cursor: pointer;
    img {
      width: 42px;
    }
    .appname {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.7);
      line-height: 17px;
      text-shadow: 0px 0px 4px rgba(204, 204, 204, 0.5);
      margin-top: 5px;
    }
  }
  .appitem:nth-child(2){margin-left:10px;margin-right:10px;}
  .appitem:hover{box-shadow: 0px 0px 10px 0px rgba(55,124,253,0.3);}
}
.otherapp {
  width: 80px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  img {
    height: 14px;
  }
  span {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0);
    line-height: 24px;
    margin-left: 8px;
  }
}
</style>
